(() => {
  const storageKey = 'aistone:favorites:v1';
  const toggleSelector = '[data-favorite-toggle]';

  const readFavorites = () => {
    try {
      const value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(value) ? value.filter((item) => item && item.id) : [];
    } catch (error) {
      return [];
    }
  };

  const writeFavorites = (favorites) => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(favorites));
    } catch (error) {
      return false;
    }

    return true;
  };

  const productFromButton = (button) => ({
    id: button.dataset.productId,
    handle: button.dataset.productHandle,
    title: button.dataset.productTitle,
    url: button.dataset.productUrl,
    image: button.dataset.productImage,
    price: Number(button.dataset.productPrice || 0),
    priceText: button.dataset.productPriceText,
  });

  const updateButton = (button, favorites) => {
    const isFavorite = favorites.some((item) => item.id === button.dataset.productId);
    const label = isFavorite ? button.dataset.labelRemove : button.dataset.labelAdd;
    const text = button.querySelector('[data-favorite-toggle-text]');

    button.classList.toggle('is-favorite', isFavorite);
    button.setAttribute('aria-pressed', String(isFavorite));
    if (label) button.setAttribute('aria-label', label);
    if (text) text.textContent = isFavorite ? 'Saved to favorites' : 'Save to favorites';
  };

  const updateInterface = () => {
    const favorites = readFavorites();

    document.querySelectorAll(toggleSelector).forEach((button) => updateButton(button, favorites));

    renderFavoritesPage(favorites);
  };

  const createTextElement = (tag, className, text) => {
    const element = document.createElement(tag);
    element.className = className;
    element.textContent = text || '';
    return element;
  };

  const createFavoriteCard = (product) => {
    const item = document.createElement('li');
    const imageLink = document.createElement('a');
    const image = document.createElement('img');
    const title = createTextElement('h2', 'favorite-card__title', '');
    const titleLink = document.createElement('a');
    const price = createTextElement('p', 'favorite-card__price', product.priceText);
    const remove = createTextElement('button', 'favorite-card__remove', 'Remove');

    item.className = 'favorite-card';
    imageLink.className = 'favorite-card__image';
    imageLink.href = product.url;
    imageLink.setAttribute('aria-label', product.title);

    if (product.image) {
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 900;
      image.height = 900;
      imageLink.appendChild(image);
    }

    titleLink.href = product.url;
    titleLink.textContent = product.title;
    title.appendChild(titleLink);

    remove.type = 'button';
    remove.dataset.favoriteRemove = product.id;
    remove.setAttribute('aria-label', `Remove ${product.title} from favorites`);

    item.append(imageLink, title, price, remove);
    return item;
  };

  function renderFavoritesPage(favorites) {
    const page = document.querySelector('[data-favorites-page]');
    if (!page) return;

    const grid = page.querySelector('[data-favorites-grid]');
    const empty = page.querySelector('[data-favorites-empty]');
    if (!grid || !empty) return;

    grid.replaceChildren(...favorites.map(createFavoriteCard));
    grid.hidden = favorites.length === 0;
    empty.hidden = favorites.length !== 0;
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(toggleSelector);
    if (toggle) {
      const product = productFromButton(toggle);
      const favorites = readFavorites();
      const existingIndex = favorites.findIndex((item) => item.id === product.id);

      if (existingIndex >= 0) {
        favorites.splice(existingIndex, 1);
      } else {
        favorites.push(product);
      }

      writeFavorites(favorites);
      updateInterface();
      return;
    }

    const remove = event.target.closest('[data-favorite-remove]');
    if (remove) {
      const favorites = readFavorites().filter((item) => item.id !== remove.dataset.favoriteRemove);
      writeFavorites(favorites);
      updateInterface();
    }
  });

  window.addEventListener('storage', (event) => {
    if (event.key === storageKey) updateInterface();
  });

  document.addEventListener('shopify:section:load', updateInterface);

  const observer = new MutationObserver((mutations) => {
    const hasFavoriteButtons = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) => node.nodeType === Node.ELEMENT_NODE && (node.matches?.(toggleSelector) || node.querySelector?.(toggleSelector)),
      ),
    );

    if (hasFavoriteButtons) updateInterface();
  });

  const initialize = () => {
    updateInterface();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
